import { BrandKit, defaultBrandKit } from "@redotech/redo-model/brand-kit";
import { createContext, Dispatch, SetStateAction } from "react";
import { ReviewsFormForm } from "./review-form-types";

export const ReviewFormContext = createContext<ReviewsFormForm | undefined>(
  undefined,
);

export const BrandKitContext = createContext<BrandKit>(defaultBrandKit);

export const THANK_YOU_UPSELL_PAGE = "thank-you-upsell-page";
export type THANK_YOU_UPSELL_PAGE = typeof THANK_YOU_UPSELL_PAGE;

export type ReviewFormSelection = {
  selectedPageIndex: number | THANK_YOU_UPSELL_PAGE;
  selectedElementIndex: number | null;
};
export const ReviewFormSelectionContext = createContext<ReviewFormSelection>({
  selectedPageIndex: 0,
  selectedElementIndex: null,
});

export const SetReviewFormSelectionContext = createContext<
  Dispatch<SetStateAction<ReviewFormSelection>>
>(() => {});

export const UsedSemanticTagsContext = createContext<string[]>([]);

export interface ProductBeingReviewed {
  imageUrl: string;
  title: string;
  purchaseDate?: Date;
}
export const exampleProduct: ProductBeingReviewed = {
  imageUrl: "https://placehold.co/800x800",
  title: "Product title",
  purchaseDate: new Date(),
};
export const ProductBeingReviewedContext =
  createContext<ProductBeingReviewed>(exampleProduct);

export interface DiscountContext {
  formattedDiscountString: string;
  discountCode: string;
}
export const DiscountContext = createContext<DiscountContext | null>(null);
